import { createStore, applyMiddleware } from 'redux';
import Reduxthunk from 'redux-thunk';
import rootReducer from '../reducers';
import { loadState, saveState } from './localStorage';
import { throttle } from 'lodash';
import { jwt } from './jwtMiddleware';
export default function configureStore(initialState) {

    const persistedState = loadState();
  
    const store = createStore(
        rootReducer,
        persistedState,
        applyMiddleware(jwt, Reduxthunk)
        // applyMiddleware(Reduxthunk)
    );
    
    store.subscribe(throttle(() => {
        saveState(store.getState());
    },1000));

    return store;
}